import React, { Fragment, useState } from 'react';


const ShiftInfoAdmin = ({ shift }) => {

    const [this_shift, setThis_shift] = useState(shift)
    const [expenses, setExpenses] = useState([])

    const getExpenses = async () => {
        const response = await fetch("/expenses", {
            method: "GET",
            headers: { token: localStorage.token, shift_id: this_shift.shift_id }
        });

        const jsonData = await response.json()

        setExpenses(jsonData.rows);
    }

    return (
        <Fragment>
            <button type="button" className="btn btn-info" data-toggle="modal" data-target={`#id_admin${this_shift.shift_id}`} onClick={getExpenses}>
                Expand Shift
            </button>

            <div className="modal fade" id={`id_admin${this_shift.shift_id}`}>
                <div className="modal-dialog">
                    <div className="modal-content">

                        <div className="modal-header">
                            <h4 className="modal-title">Shift Information</h4>
                            <button type="button" className="close" data-dismiss="modal">&times;</button>
                        </div>

                        <div className="modal-body">
                            <p>Shift ID: {this_shift.shift_id}</p>

                            <p>Shift Description: {this_shift.description}</p>

                            <p>Expenses: {expenses.length}</p>
                            {expenses.map((expense,index) => {
                                var contains_proof = ((expense.submitted_proof) ? "Proof submitted" : "No proof submitted");
                                return <p key={"expense_id_shift" + index}>Cost: ${expense.cost_cents/100}. Description: {expense.expense_description}. {contains_proof}</p>
                            })}
                            {expenses.length == 0 && <p>No expenses recorded for this shift</p>}
                            <p>Kilometres Travelled: {this_shift.m_travelled}</p>

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-success" data-dismiss="modal">Close</button>
                        </div>

                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default ShiftInfoAdmin;